import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  Input
} from '@chakra-ui/react'
import { FC } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationCurveExecutation from '@hook/parametrization/use-curve-executation'

const ParametrizationCurveExecutationCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    paramsEdit,
    selected,
    data,
    handleUpdateEditParams,
    createData,
    updateDataCurve
  } = useParametrizationCurveExecutation()

  const checkIdExists = (): boolean => {
    return data.some(
      item =>
        item['id-id'] === selected && item['curva-executado'] === 'Executado'
    )
  }

  return (
    <>
      {selected !== 0 ? (
        !checkIdExists() ? (
          <Button
            fontSize={14}
            size="sm"
            marginLeft={2}
            leftIcon={<FiEdit2 />}
            colorScheme="green"
            variant="outline"
            onClick={onOpen}
          >
            Editar
          </Button>
        ) : null
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            bg="white"
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0
                  ? 'Editar Curva Execução'
                  : 'Criar Curva Execução'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <FormLabel>Data Inicio</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.data}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'data',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  updateDataCurve()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationCurveExecutationCreate
